export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-social-hi5-0089c9eef6d002c26fd643c8b91e852b.svg";